module.exports = __webpack_public_path__ + "static/img/011酒庄官网2.8f7c89c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/011酒庄官网2.jpg
// module id = lq3q
// module chunks = 0